import script from "./531MethodView.vue?vue&type=script&setup=true&lang=ts"
export * from "./531MethodView.vue?vue&type=script&setup=true&lang=ts"

import "./531MethodView.vue?vue&type=style&index=0&id=54578003&lang=css"

const __exports__ = script;

export default __exports__